
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"567","height":"517","viewBox":"0 0 567 517","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M476.487 521.214C542.589 506.328 581.894 437.952 561.678 373.01L553.054 345.308C546.024 322.724 546.012 298.535 553.02 275.958L561.616 248.265C581.769 183.344 542.397 114.929 476.281 99.9773L448.077 93.5998C425.086 88.4005 404.209 76.2949 388.23 58.8951L368.629 37.5515C322.68 -12.4837 244.003 -12.5225 198.105 37.4672L178.524 58.7914C162.562 76.1755 141.699 88.2606 118.711 93.437L90.5126 99.7869C24.4109 114.672 -14.8934 183.048 5.32233 247.99L13.9471 275.691C20.977 298.276 20.9884 322.465 13.9802 345.042L5.38281 372.735C-14.7679 437.656 24.6026 506.073 90.7191 521.022L118.923 527.401C141.916 532.6 162.791 544.705 178.771 562.105L198.37 583.449C244.321 633.484 322.996 633.522 368.897 583.533L388.476 562.209C404.44 544.824 425.303 532.74 448.289 527.564L476.487 521.214Z"}})])
          )
        }
      }
    